<!--
 * @description: 
 * @Author: HaoJG
 * @Date: 2022-03-03 13:50:44
 * @Lasteditors: HaoJG
 * @LastEditTime: 2022-03-22 16:15:37
-->
<template>
  <div style='display:flex;height:600px'>
    <div style='width:800px;left:50%;flex-grow:1;align-self:center'>
      <img src="/static/images/logo.png" alt="" style='width:200px;height:200px;'>
      <h2>{{webname}}</h2>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menulist: JSON.parse(sessionStorage.getItem("menulist")),
      webname: sessionStorage.getItem('webname'),
    };
  },
  methods: {

  },
  created: function () {
  }
};
</script>
